function checkScrollPosition() {
	const st = window.pageYOffset || document.documentElement.scrollTop;

	if (document.body.classList.contains('is-menu-open')) {
		return;
	}

	if (st > 70) {
		document.body.classList.add('is-scrolled');
	} else {
		document.body.classList.remove('is-scrolled');
	}
}

window.addEventListener('load', checkScrollPosition);
window.addEventListener('scroll', checkScrollPosition);